/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const UserConfirmationEmailPost = {
  id: 'user.confirmation-email.post',
  tag: 'User',
  summary: 'User - confirmation email',
  description: 'Send confirmation email to user',
  method: 'post',
  flags: { isAuthorized: true },
  route: () => `/user/confirmation-email`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
